module.exports = __webpack_public_path__ + "static/newblogs-aac741ab23d741e93808fb1effe02d8d.jpg";